import React, { ReactNode } from 'react';

interface PageErrorProps {
  title: string;
  children: ReactNode;
}

const PageError: React.FC<PageErrorProps> = ({ title, children }) => {
  return (
    <div className='h-[65vh] flex gap-10 flex-col text-center justify-center font-bold text-primary'>
      <div className='text-3xl'>
        <h1>{title}</h1>
      </div>
      <div>{children}</div>
    </div>
  );
};

export default PageError;
